import PropTypes from 'prop-types';
import {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Confirm} from 'semantic-ui-react';

import {addSuccessMessage} from 'state/actions';

// it would be nice to have a generic base component for RemoveProjectModal and the component below
const RemoveWordPressEnvironmentModal = ({
  trigger,
  onConfirm,
  content,
  successMessage,
  confirmButtonContent,
}) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const dispatch = useDispatch();

  return (
    <Confirm
      trigger={trigger}
      onConfirm={async () => {
        setIsDeleting(true);
        try {
          await onConfirm();
          setIsDeleting(false);
          setDeleteModalOpen(false);
          dispatch(addSuccessMessage(successMessage));
        } finally {
          setIsDeleting(false);
        }
        setDeleteModalOpen(false);
      }}
      onOpen={() => setDeleteModalOpen(true)}
      onCancel={() => setDeleteModalOpen(false)}
      header="Confirmation required"
      content={content}
      open={deleteModalOpen}
      confirmButton={{
        negative: true,
        content: confirmButtonContent,
        disabled: isDeleting,
        loading: isDeleting,
      }}
      cancelButton={{content: 'Cancel', disabled: isDeleting, loading: isDeleting}}
      closeOnDimmerClick={!isDeleting}
      closeOnDocumentClick={!isDeleting}
    />
  );
};

RemoveWordPressEnvironmentModal.propTypes = {
  trigger: PropTypes.oneOfType([PropTypes.node, PropTypes.object]).isRequired,
  onConfirm: PropTypes.func.isRequired,
  successMessage: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
  confirmButtonContent: PropTypes.string.isRequired,
};

export default RemoveWordPressEnvironmentModal;
